import React from 'react';
import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import { LanBooking, LanRegistration } from 'types/intra';
import { bookingDisplayName, isAssignedLocation } from './intraUtils';

interface SeatSwapConfirmDialogProps {
    opened: boolean;
    source: LanBooking | null;
    occupant: LanBooking | null;
    location: string;
    registrations: LanRegistration[];
    confirming?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const SeatSwapConfirmDialog: React.FC<SeatSwapConfirmDialogProps> = ({
    opened,
    source,
    occupant,
    location,
    registrations,
    confirming = false,
    onConfirm,
    onCancel
}) => {
    if (!source || !occupant) {
        return null;
    }

    const sourceName = bookingDisplayName(source, registrations);
    const occupantName = bookingDisplayName(occupant, registrations);
    const sourceHasSeat = isAssignedLocation(source.location);

    return (
        <Modal opened={opened} onClose={onCancel} title="Vahvista paikanvaihto" centered>
            <Stack gap="md">
                {sourceHasSeat ? (
                    <Text>
                        Vaihdetaanko paikat osallistujien <strong>{sourceName}</strong> ({source.location}) ja{' '}
                        <strong>{occupantName}</strong> ({location}) välillä?
                    </Text>
                ) : (
                    <Text>
                        <strong>{sourceName}</strong> ei ole vielä paikkaa. Siirretäänkö paikka {location} hänelle?
                        Tällöin <strong>{occupantName}</strong> jää ilman paikkaa.
                    </Text>
                )}
                <Group justify="flex-end">
                    <Button variant="default" onClick={onCancel} disabled={confirming}>
                        Peruuta
                    </Button>
                    <Button color="violet" onClick={onConfirm} loading={confirming}>
                        {sourceHasSeat ? 'Vaihda paikat' : 'Siirrä paikka'}
                    </Button>
                </Group>
            </Stack>
        </Modal>
    );
};

export default SeatSwapConfirmDialog;
